import { useParams } from 'react-router-dom'
import { Container, Typography, Box } from '@mui/material'

export default function ProductDetailPage() {
  const { id } = useParams()

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box>
        <Typography variant="h4" component="h1" gutterBottom>
          Product Detail
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Product ID: {id}
        </Typography>
        <Typography variant="body2" sx={{ mt: 2 }}>
          This page will display detailed information about the selected solar product.
        </Typography>
      </Box>
    </Container>
  )
}